import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BeamerWrapperComponent } from './beamer-wrapper.component';

@NgModule({
    imports: [
        CommonModule,
        // IMPORTANT: declare empty routes here and import the routes from the main routing module!
        //            the wrapper module must be imported from the main module.
        RouterModule.forChild([]),
        BeamerWrapperComponent,
    ],
    exports: [BeamerWrapperComponent],
    providers: [],
})
export class BeamerWrapperModule {}
